<script lang="ts">
  export let width = '100vw';
  export let scrollable = false;
  export let fullscreen = false;
  export let transitions = {
    duration: {
      in: 150,
      out: 150
    },
    translate: {
      in: "20%",
      out: "20%"
    },
    opacity: {
      start: 0,
      end: 0
    },
    navigationDelay: 150
  };
</script>

<svelte:head>
  <style>
    .device-frame {
      background: var(--theme-bg-color, var(--bg-color, white));
    }
    html[data-theme='dark'] .device-frame {
      background: var(--theme-bg-color-dark, #1a1a1a);
    }
    div[data-theme='dark'] .device-frame {
      background: var(--theme-bg-color-dark, #1a1a1a);
    }
  </style>
</svelte:head>

<div class="frames-container">
  <div 
    class="device-frame" 
    class:is-scrollable={scrollable}
    class:is-fullscreen={fullscreen} 
    style="
      --frame-width: {width};
      --animation-duration: 0.15s cubic-bezier(0.4, 0, 0.2, 1);
      --transition: 150ms ease-in-out;
      --theme-transition: var(--transition);
    "
  >
    <div class="device-screen">
      <slot />
    </div>
  </div>
</div>

<style>
  .frames-container {
    width: 100%;
    height: 100dvh;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .device-frame {
    width: 100%;
    height: 100%;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    position: relative;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    transition: all 400ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  .device-screen {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    min-height: 0; /* Important for nested flex containers */
  }

  /* Only apply max dimensions on landscape and larger screens */
  @media (orientation: landscape) and (min-width: 1024px) {
    .device-frame {
      max-width: 380px;
      max-height: 780px;
      height: 100%;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }
    
    .device-frame.is-scrollable {
      max-height: 100%;
      overflow-y: auto;
    }
  }

  /* Apply tablet-specific styling only for larger devices */
  /* Changed from: @media (orientation: portrait), (max-width: 1023px) */
  @media (orientation: portrait) and (min-width: 768px) and (min-height: 900px) {
    /* This now only targets actual tablets with sufficient height and width */
    .device-frame {
      max-width: 420px;
      max-height: 840px;
      height: 100%;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }
    .frames-container {
      padding: 0;
    }
  }

  /* Remove padding on all mobile devices */
  @media (max-width: 767px) {
    .frames-container {
      padding: 0;
    }
  }

  :global([data-theme='dark']) .frames-container {
    background: #121212;
  }

  /* Fullscreen mode - remove portrait frame constraints */
  .device-frame.is-fullscreen {
    max-width: none !important;
    max-height: none !important;
    width: 100% !important;
    height: 100% !important;
    box-shadow: none !important;
  }

  @media (orientation: landscape) and (min-width: 1024px) {
    .device-frame.is-fullscreen {
      max-width: none !important;
      max-height: none !important;
    }
  }

  @media (orientation: portrait) and (min-width: 768px) and (min-height: 900px) {
    .device-frame.is-fullscreen {
      max-width: none !important;
      max-height: none !important;
    }
  }
</style> 